import { render, staticRenderFns } from "./DingTalkEventList.vue?vue&type=template&id=5942e72c&scoped=true"
import script from "./DingTalkEventList.vue?vue&type=script&lang=js"
export * from "./DingTalkEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942e72c",
  null
  
)

export default component.exports